import script from "./LeaderProjectTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderProjectTitle.vue?vue&type=script&setup=true&lang=js"

import "./LeaderProjectTitle.vue?vue&type=style&index=0&id=54dbdef0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54dbdef0"]])

export default __exports__